<ng-container *transloco="let t;">
    <div class="slideout-content">
        <!-- Modal to add attachments starts-->
        <div class="modalsd modal-slide-in sdfade playbook-right-bar" id="modals-slide-in">
            <div class="modal-dialog">
   
                <form class="playbook-modal modal-content pt-0">
                                   @if(loading$ | async) {
                    <!-- <app-skeleton  section="legal_hub_sidebar"></app-skeleton> -->
                }@else{  
                    <div class="modal-header mb-1 d-flex justify-content-between align-items-center px-2 py-1">
                        <div class="d-flex justify-content-start align-items-center">
                            <h5 class="modal-title" id="exampleModalLabel"> {{playbookForm?.get('name')?.value}}  </h5>
                        </div>
                        <div class="d-flex justify-content-between align-items-center text-dark">
                                <div class="documentRightMenuDropdown" ngbDropdown>
                                    <a ngbDropdownToggle href="javascript:void(0);" class="hide-arrow ms-1 d-flex" id="todoActions">
                                        <i class="feather font-medium-1 icon-more-vertical cursor-pointer text-body"></i>
                                    </a>
                                    <div ngbDropdownMenu class="dropdown-menu-right" aria-labelledby="todoActions">
                                        <a ngbDropdownItem href="javascript:void(0)" (click)="deletePlayBook(playbookForm?.get('id')?.value)" class="dropdown-item sort-asc text-danger" tabindex="0"><i class="feather font-medium-1 me-50 icon-trash"></i> {{ t('Delete permanently - label (general) - Delete permanently') }} </a>
                                    </div>
                                </div>
                                
                                <i
                                    class="feather font-medium-1 icon-x ms-1 cursor-pointer"
                                    placement="auto"
                                    [autoClose]="true"
                                    triggers="hover"
                                    [ngbTooltip]="t('Close tooltip (close modal button tooltip) - Close')"
                                    data-dismiss="modal"
                                    aria-label="Close"
                                    (click)="closeSiderBar()"
                                ></i>
                            </div>
                    </div>
                    <div class="modal-body flex-grow-1 p-0">
                        <ul ngbNav #navJustified="ngbNav"  class="nav-tabs nav-justified playbook-right-barTabs" >
                            <li [ngbNavItem]="LegalHubTabs.SETTINGS" destroyOnHide="false" [ngClass]="{'invalid': isSettingsTabInvalid && submitted}">
                                <a ngbNavLink>{{t("Settings tab title (Legal Hub right bar) - Settings")}}</a>
                                   <ng-template ngbNavContent>
                                          <app-legal-hub-settings-tab [submitted]="submitted" (submitClicked)="onSubmit()" [formGroup]="playbookForm"></app-legal-hub-settings-tab>
                                   </ng-template>
                            </li>
                            <li [ngbNavItem]="LegalHubTabs.GUIDELINES" destroyOnHide="false"  [ngClass]="{'invalid': isGuidelinesTabInvalid && submitted}">
                                <a ngbNavLink>{{t("Guidelines tab title (Legal Hub right bar) - Guidelines")}}</a>
                                <ng-template ngbNavContent>
                                    <app-legal-hub-guidelines-tab [submitted]="submitted" (submitClicked)="onSubmit()" [formGroup] = "playbookForm"></app-legal-hub-guidelines-tab>
                                </ng-template>
                            </li>
                        </ul>
                        <div [ngbNavOutlet]="navJustified" class="mt-2"></div>
                    </div>
    }
                </form>
            
            </div>
        </div>
    </div>
